import React from "react";
import AlertIcon from "../../assets/icons/alert-slide.png";

export const VOLVER = ({
  width = 20,
  height = 20,
  color = "#356ab3",
  strokeWidth = 0.5
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 21"
  >
    <path
      d="M16.8150578 21H3.97464887c-.42268862 0-.76435555-.3451198-.76435555-.7720801s.34166693-.7720801.76435555-.7720801H16.8150578c1.3269212 0 5.6562311-.4701968 5.6562311-6.524077 0-5.5528001-5.0776139-5.7133928-5.6562311-5.7133928H.76435555C.34243129 7.21837 0 6.87325 0 6.44629s.34243129-.7720801.76435555-.7720801H16.8150578C19.483423 5.67421 24 7.20293 24 12.93176c0 5.95505-3.8706965 8.06824-7.1849422 8.06824"
      fill={color}
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M6.38206312 12.8931588c-.19567502 0-.39135004-.0756638-.54039937-.2262195L.22365044 6.99215052c-.29809867-.30111125-.29809867-.78983796 0-1.09172128L5.84166375.22641249c.29886302-.30188332.78193573-.30188332 1.08079875 0 .29886302.30111125.29886302.78983796 0 1.09172128L1.84484856 6.44628988l5.07761394 5.12892822c.29886302.3018833.29886302.7898379 0 1.0917212-.14904933.1505557-.34472435.2262195-.54039938.2262195"
      fill={color}
      stroke={color}
      strokeWidth={strokeWidth}
    />
  </svg>
);

export const PDF = ({ width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="currentColor"
    className="bi bi-filetype-pdf"
    viewBox="0 0 16 16"
    color="#203C77"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
    />
  </svg>
);

export const XML = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    className="bi bi-filetype-xml"
    viewBox="0 0 16 16"
    color="#203C77"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999zm4.71-.674h1.696v.674H8.4V11.85h.791z"
    />
  </svg>
);

export const HTML = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    className="bi bi-filetype-html"
    viewBox="0 0 16 16"
    color="#203C77"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zm-9.736 7.35v3.999h-.791v-1.714H1.79v1.714H1V11.85h.791v1.626h1.682V11.85h.79Zm2.251.662v3.337h-.794v-3.337H4.588v-.662h3.064v.662zm2.176 3.337v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596H9.93L8.79 11.85h-.805v3.999zm4.71-.674h1.696v.674H12.61V11.85h.79v3.325Z"
    />
  </svg>
);

export const CSV = ({ width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="currentColor"
    className="bi bi-filetype-csv"
    viewBox="0 0 16 16"
    color="#203C77"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
    />
  </svg>
);

export const XLSXICON = ({ width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="currentColor"
    className="bi bi-filetype-xlsx"
    viewBox="0 0 16 16"
    color="#203C77"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"
    />
  </svg>
);

export const INFO = ({ color_icono, color_fondo }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g transform="scale(1, -1) translate(0, -24)">
        {/* Círculo de fondo para cambiar el color de fondo */}
        <circle cx="12" cy="12" r="12" fill={color_fondo} />

        {/* El punto de la i */}
        <path d="M11.9285419,15.716129 C11.4725419,15.716129 11.1024774,15.3460645 11.1024774,14.8900645 L11.1024774,5.80645161 C11.1024774,5.35045161 11.4725419,4.9803871 11.9285419,4.9803871 C12.3845419,4.9803871 12.7546065,5.35045161 12.7546065,5.80645161 L12.7546065,14.8900645 C12.7546065,15.3460645 12.3845419,15.716129 11.9285419,15.716129"
          fill={color_icono}
        />
        {/* El palo de la i */}
        <path d="M11.9922581,19.0193806 C11.7654194,19.0193806 11.5385806,18.9396387 11.3597419,18.7762839 C10.9726452,18.4240258 10.9362581,17.8340903 11.2885161,17.4477677 L11.3063226,17.4276387 C11.6593548,17.0405419 12.2585806,17.012671 12.6449032,17.3657032 C13.032,17.7179613 13.059871,18.3171871 12.7076129,18.7042839 C12.5187097,18.9125419 12.2554839,19.0193806 11.9922581,19.0193806"
          fill={color_icono}
        />
        {/* Circulo externo */}
        <path d="M12,22.4516129 C6.22993548,22.4516129 1.5483871,17.7793548 1.5483871,12 C1.5483871,6.23225806 6.22296774,1.5483871 12,1.5483871 C17.739871,1.5483871 22.4516129,6.19741935 22.4516129,12 C22.4516129,17.7723871 17.7770323,22.4516129 12,22.4516129 M12,0 C5.37290323,0 0,5.37522581 0,12 C0,18.6286452 5.37290323,24 12,24 C18.6270968,24 24,18.6286452 24,12 C24,5.37522581 18.6270968,0 12,0"
          fill={color_icono}
        />
      </g>
    </g>
  </svg>
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="20"
  //   height="20"
  //   fill={color_icono}
  //   className="bi bi-info-circle"
  //   viewBox="0 0 16 16"
  // >
  //   <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
  //   <circle cx="8" cy="8" r="7" fill={color_fondo} />
  //   <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  // </svg>
);

export const CALENDAR = () => (
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="20"
  //   height="20"
  //   fill="currentColor"
  //   className="bi bi-calendar3"
  //   viewBox="0 0 16 16"
  // >
  //   <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
  //   <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="24px"
    viewBox="0 0 21 24"
    version="1.1"
  >
    <path d="M32.7500001,15 L30.5,15 L30.5,12.5625 C30.5,12.253125 30.2468751,12 29.9375001,12 L29.5625001,12 C29.2531251,12 29,12.253125 29,12.5625 L29,15 L20,15 L20,12.5625 C20,12.253125 19.746875,12 19.4375,12 L19.0625,12 C18.753125,12 18.5,12.253125 18.5,12.5625 L18.5,15 L16.25,15 C15.0078125,15 14,16.0078125 14,17.25 L14,33.7500001 C14,34.9921876 15.0078125,36 16.25,36 L32.7500001,36 C33.9921876,36 35,34.9921876 35,33.7500001 L35,17.25 C35,16.0078125 33.9921876,15 32.7500001,15 Z M16.25,16.5 L32.7500001,16.5 C33.1625001,16.5 33.5,16.8375 33.5,17.25 L33.5,19.5 L15.5,19.5 L15.5,17.25 C15.5,16.8375 15.8375,16.5 16.25,16.5 Z M32.7500001,34.5000001 L16.25,34.5000001 C15.8375,34.5000001 15.5,34.1625001 15.5,33.7500001 L15.5,21.0000001 L33.5,21.0000001 L33.5,33.7500001 C33.5,34.1625001 33.1625001,34.5000001 32.7500001,34.5000001 Z M20.9375,27.0000001 L19.0625,27.0000001 C18.753125,27.0000001 18.5,26.7468751 18.5,26.4375001 L18.5,24.5625001 C18.5,24.2531251 18.753125,24.0000001 19.0625,24.0000001 L20.9375,24.0000001 C21.246875,24.0000001 21.5,24.2531251 21.5,24.5625001 L21.5,26.4375001 C21.5,26.7468751 21.246875,27.0000001 20.9375,27.0000001 Z M25.4375001,27.0000001 L23.5625001,27.0000001 C23.2531251,27.0000001 23.0000001,26.7468751 23.0000001,26.4375001 L23.0000001,24.5625001 C23.0000001,24.2531251 23.2531251,24.0000001 23.5625001,24.0000001 L25.4375001,24.0000001 C25.7468751,24.0000001 26.0000001,24.2531251 26.0000001,24.5625001 L26.0000001,26.4375001 C26.0000001,26.7468751 25.7468751,27.0000001 25.4375001,27.0000001 Z M29.9375001,27.0000001 L28.0625001,27.0000001 C27.7531251,27.0000001 27.5000001,26.7468751 27.5000001,26.4375001 L27.5000001,24.5625001 C27.5000001,24.2531251 27.7531251,24.0000001 28.0625001,24.0000001 L29.9375001,24.0000001 C30.2468751,24.0000001 30.5000001,24.2531251 30.5000001,24.5625001 L30.5000001,26.4375001 C30.5000001,26.7468751 30.2468751,27.0000001 29.9375001,27.0000001 Z M25.4375001,31.5000001 L23.5625001,31.5000001 C23.2531251,31.5000001 23.0000001,31.2468751 23.0000001,30.9375001 L23.0000001,29.0625001 C23.0000001,28.7531251 23.2531251,28.5000001 23.5625001,28.5000001 L25.4375001,28.5000001 C25.7468751,28.5000001 26.0000001,28.7531251 26.0000001,29.0625001 L26.0000001,30.9375001 C26.0000001,31.2468751 25.7468751,31.5000001 25.4375001,31.5000001 Z M20.9375,31.5000001 L19.0625,31.5000001 C18.753125,31.5000001 18.5,31.2468751 18.5,30.9375001 L18.5,29.0625001 C18.5,28.7531251 18.753125,28.5000001 19.0625,28.5000001 L20.9375,28.5000001 C21.246875,28.5000001 21.5,28.7531251 21.5,29.0625001 L21.5,30.9375001 C21.5,31.2468751 21.246875,31.5000001 20.9375,31.5000001 Z M29.9375001,31.5000001 L28.0625001,31.5000001 C27.7531251,31.5000001 27.5000001,31.2468751 27.5000001,30.9375001 L27.5000001,29.0625001 C27.5000001,28.7531251 27.7531251,28.5000001 28.0625001,28.5000001 L29.9375001,28.5000001 C30.2468751,28.5000001 30.5000001,28.7531251 30.5000001,29.0625001 L30.5000001,30.9375001 C30.5000001,31.2468751 30.2468751,31.5000001 29.9375001,31.5000001 Z" id="Icons-FA-/-20-/calendar-alt"></path>

  </svg>
);

export const DOWNLOAD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    className="bi bi-box-arrow-down"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z"
    />
    <path
      fillRule="evenodd"
      d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"
    />
  </svg>
);

export const EXPORT = ({ color_icono, color_fondo }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill={color_icono}
    className="bi bi-arrow-up-right-square"
    viewBox="0 0 20.163 20.211"
  >

    {/* Fondo */}
    <path fill={color_fondo} d="M0 0h20.163v20.21H0z" />

    {/* flecha */}
    <path
      d="M1.345 19.87c-.401-.155-.822-.558-1.013-.971l-.156-.338-.016-7.05C.145 5.098.152 4.428.232 4.125c.15-.562.502-.965 1.081-1.236l.314-.146h4.158c4.828 0 4.31-.08 4.31.667-.001.252-.02.485-.041.518-.118.176-.262.182-4.218.182-4.374 0-4.11-.022-4.268.354-.112.267-.112 13.556 0 13.823.16.383-.44.354 7.254.354h6.929l.183-.182.183-.183v-7.992l.147-.116c.13-.102.202-.114.596-.098.37.015.461.037.526.124.066.09.075.713.062 4.29l-.014 4.184-.152.287a2.18 2.18 0 01-.881.872l-.258.127-7.258.011c-7.17.011-7.261.01-7.54-.097zm14.94-.164c.387-.18.718-.51.899-.895l.142-.303.015-4.056c.014-3.661.007-4.065-.07-4.143-.064-.063-.191-.085-.483-.085-.349 0-.407.014-.48.119-.074.105-.084.58-.084 4.068v3.948l-.116.148c-.245.31.116.296-7.303.296-7.33 0-7.038.01-7.285-.267-.107-.119-.108-.196-.108-7.164V4.328l.176-.176.176-.175 4.06-.027c3.53-.023 4.067-.037 4.11-.107.09-.14.065-.785-.032-.882-.078-.077-.494-.084-4.207-.071l-4.121.015-.27.142c-.372.197-.659.497-.84.88l-.155.327.014 7.18.014 7.181.123.23c.156.292.451.619.693.768.43.265.167.256 7.732.245l7.097-.01zM5.378 14.914c-.264-.226-.365-.476-.281-.701.034-.092 2.613-2.705 6.248-6.332l6.19-6.177-1.782.01-1.782.01-.147-.145c-.28-.278-.225-1.054.086-1.22.067-.036 1.093-.055 2.925-.055h2.821l.14.167.141.166-.014 2.814-.015 2.814-.151.13c-.13.111-.205.129-.555.129-.375 0-.416-.011-.562-.157l-.157-.157V2.69l-6.224 6.207c-6.218 6.2-6.223 6.206-6.441 6.206-.172 0-.266-.04-.44-.189zM12.2 8.741c4.84-4.825 6.294-6.246 6.365-6.219.086.033.091.17.073 1.836l-.02 1.8.15.129c.218.187.685.186.873-.002l.132-.132V.633l-.141-.11c-.14-.11-.192-.112-2.799-.112-3.188 0-3.027-.033-3.027.631 0 .235.025.328.117.425l.117.124h1.845c1.436 0 1.845.015 1.845.067 0 .036-2.818 2.878-6.263 6.314-5.11 5.096-6.263 6.273-6.263 6.387 0 .235.406.636.644.636.044 0 2.903-2.814 6.352-6.254z"
      fill={color_icono}
    />
    <path
      d="M2.035 19.813c-.627-.035-.796-.102-1.16-.457a2.438 2.438 0 01-.44-.59L.35 18.61l-.017-7.17-.017-7.17.107-.227c.234-.494.483-.76.946-1.015l.207-.113h4.097c3.194 0 4.112.006 4.163.029.102.045.122.127.124.501 0 .28-.006.346-.037.378-.027.027-.118.044-.334.06-.334.026-4.356.07-6.449.07H1.767l-.185.186-.184.186.001 6.223c.001 6.219.015 7.781.07 7.919.078.2.224.26.74.305.519.044 12.693.042 13.198-.002.477-.042.568-.074.71-.251l.112-.14.012-3.862c.008-2.47.02-3.913.036-4.003.017-.099.044-.16.087-.203.06-.061.066-.062.426-.062.439 0 .48.016.51.196.011.063.02 1.9.019 4.083l-.002 3.968-.1.207c-.247.517-.546.812-1.065 1.05l-.188.088-6.788-.004c-3.733-.002-6.946-.012-7.14-.024z"
      fill={color_icono}
    />
    <path
      d="M5.766 14.966c-.207-.057-.546-.422-.546-.587 0-.118.471-.6 6.558-6.699 3.074-3.082 5.675-5.697 5.779-5.812.103-.115.181-.216.172-.224-.042-.042-.395-.052-1.968-.054L14.06 1.59l-.09-.098c-.124-.135-.146-.21-.147-.512-.001-.31.019-.362.166-.434.22-.108.384-.115 2.878-.115 1.288 0 2.414.009 2.502.02.13.016.184.036.28.107l.12.088v2.748l.001 2.749-.09.086a.572.572 0 01-.396.178.722.722 0 01-.532-.156l-.117-.094.008-1.752c.006-1.204 0-1.773-.017-1.818-.072-.185.15-.396-6.549 6.254-4.523 4.49-6.008 5.955-6.163 6.078-.066.051-.098.062-.147.048z"
      fill={color_icono}
    />
  
    {/* <path
      fillRule="evenodd"
      d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707z"
    /> */}
  </svg>
);

export const DROPDOWN = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    className="bi bi-chevron-compact-down"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67"
    />
  </svg>
);

export const DROPUP = ({ color_icono }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="100%"
    height="100%"
    // viewBox="0 -960 960 960" 
    viewBox="200 -800 600 600"
  >
    <path
      d="M274.924-379.539q-8.693-8.692-8.693-21.076 0-12.385 8.693-21.077l179.769-179.769q5.615-5.615 11.846-7.923 6.23-2.307 13.461-2.307t13.461 2.307q6.231 2.308 11.846 7.923l180.769 180.769q8.308 8.308 8.308 20.077 0 11.769-9.308 21.076-8.692 8.692-21.076 8.692t-21.076-8.692L480-542.463 316.076-378.539q-8.307 8.308-20.076 8.308t-21.076-9.308Z"
      fill={color_icono || "currentColor"} // si viene informado parámetro uso parámetro, si no currentcolor
    />
  </svg>
    // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="20"
  //   height="20"
  //   fill="currentColor"
  //   className="bi bi-chevron-compact-up"
  //   viewBox="0 0 16 16"
  // >
  //   <path
  //     fillRule="evenodd"
  //     d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894z"
  //   />
  // </svg>
);        

export const ERASER = ({ color_icono }) => (
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="20"
  //   height="20"
  //   fill="currentColor"
  //   className="bi bi-eraser"
  //   viewBox="0 0 16 16"
  // >
  //   <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293z" />
  // </svg>
  <svg xmlns="http://www.w3.org/2000/svg" 
    height="24"
    width="24"
    viewBox="0 -960 960 960" 
    fill={color_icono || "currentColor"} // si viene informado parámetro uso parámetro, si no currentcolor
  >
    <path d="M690-240h190v80H610l80-80Zm-500 80-85-85q-23-23-23.5-57t22.5-58l440-456q23-24 56.5-24t56.5 23l199 199q23 23 23 57t-23 57L520-160H190Zm296-80 314-322-198-198-442 456 64 64h262Zm-6-240Z"/>
  </svg>
);

export const BUSQUEDA = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    className="bi bi-search"
    viewBox="0 0 16 16"
  >
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
  </svg>
);

export const ENLACE = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="16"
    fill="currentColor"
    className="bi bi-link"
    viewBox="0 0 100 50"
  >
    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
  </svg>
);


export const EYE = ({ color_icono ="#203C77", color_fondo, height=20, width=24}) => (
  <svg
  width={width}
  height={height}
    fill={color_icono}
    // viewBox="0 0 33.864 21.881" 
    viewBox="0 0 5.292 3.914"
    xmlns="http://www.w3.org/2000/svg">

    <path
      d="M2.428 3.91c-.614-.06-1.168-.347-1.68-.874a4.44 4.44 0 01-.708-.963c-.041-.08-.042-.083-.039-.126a.255.255 0 01.041-.114c.244-.453.612-.907.986-1.22.419-.349.873-.552 1.354-.606a3.39 3.39 0 01.48.003c.58.068 1.118.358 1.615.868.226.233.45.527.621.813.096.16.117.207.12.26.004.045.002.05-.034.118-.083.158-.23.385-.359.557-.384.51-.83.885-1.294 1.09a2.322 2.322 0 01-.648.183c-.105.014-.36.02-.455.01zm.48-.032c.279-.044.489-.113.734-.238.191-.097.36-.21.55-.367.104-.086.366-.35.461-.464.2-.24.385-.51.505-.736.065-.123.064-.128-.052-.329A4.196 4.196 0 004.048.526 2.476 2.476 0 002.912.035 1.665 1.665 0 002.62.018c-.197 0-.27.006-.434.039-.648.13-1.262.56-1.78 1.25a4.575 4.575 0 00-.353.55c-.055.107-.052.122.095.365.35.585.826 1.075 1.314 1.356.308.178.589.27.959.313.063.007.42-.002.488-.013zm-.427-.258a2.03 2.03 0 01-.759-.216 2.737 2.737 0 01-.761-.574 3.68 3.68 0 01-.348-.405c-.134-.18-.3-.44-.3-.469 0-.03.162-.284.297-.465.22-.293.476-.555.733-.749.36-.271.764-.428 1.163-.45.402-.022.777.078 1.16.309.202.12.356.244.564.452.158.158.255.269.377.432.136.182.3.439.3.472 0 .03-.171.3-.295.464-.432.576-.933.963-1.449 1.12a2.26 2.26 0 01-.307.067c-.076.01-.309.018-.375.012zm.342-.027c.462-.054.919-.29 1.328-.683.27-.261.493-.54.69-.869l.051-.085-.019-.033a4.283 4.283 0 00-.625-.826C3.815.654 3.347.392 2.858.323a2.496 2.496 0 00-.473-.004C1.94.38 1.54.579 1.137.938c-.275.245-.569.61-.773.957l-.036.062.064.105c.264.434.607.823.959 1.087.25.187.523.324.787.393.086.023.229.05.3.056.08.007.301.004.385-.006zm-.37-.82a.833.833 0 01-.11-1.604.846.846 0 01.555.006c.19.071.356.221.448.404a.872.872 0 01.046.64.81.81 0 01-.19.314.805.805 0 01-.44.24c-.072.014-.24.014-.308 0zm.347-.027a.818.818 0 00.611-.872.815.815 0 00-.235-.493.79.79 0 00-.884-.171.82.82 0 00-.462.944c.07.272.27.487.538.577.128.043.3.05.432.015zm-.321-.267a.49.49 0 01-.24-.14.476.476 0 01-.158-.36.474.474 0 01.057-.272.41.41 0 01.097-.134.393.393 0 01.136-.098.523.523 0 01.636.12.574.574 0 01.123.232.663.663 0 01-.003.268.54.54 0 01-.383.384.65.65 0 01-.266 0zm.273-.022a.523.523 0 00.086-.965.455.455 0 00-.228-.056.523.523 0 00-.5.394.687.687 0 00-.003.242c.049.2.208.354.406.396a.58.58 0 00.239-.012z" />
    <path
      d="M2.537 2.764a.814.814 0 01-.488-1.384.784.784 0 01.913-.151.816.816 0 01.428.924.822.822 0 01-.675.608 1.368 1.368 0 01-.178.003zm.134-.273a.508.508 0 00.32-.154.547.547 0 00.145-.278.589.589 0 00.005-.107c0-.07 0-.083-.006-.11a.56.56 0 00-.189-.306.52.52 0 00-.563-.068.428.428 0 00-.158.114.409.409 0 00-.087.121c-.05.1-.06.145-.057.262a.488.488 0 00.047.229c.05.1.153.202.251.25.06.03.118.044.19.048a.698.698 0 00.102-.001z" />
    <path
      d="M2.353 3.88a2.377 2.377 0 01-1.045-.404C.868 3.182.465 2.742.141 2.203c-.104-.173-.124-.22-.116-.265.012-.069.206-.389.37-.61.233-.314.51-.597.782-.8.365-.272.734-.43 1.15-.493.084-.012.378-.018.482-.009.308.028.653.14.945.31.507.293.988.797 1.348 1.41.095.163.106.196.086.253-.024.069-.152.284-.272.457a3.98 3.98 0 01-.39.487c-.27.288-.521.492-.79.642-.263.146-.491.23-.765.279a2.717 2.717 0 01-.618.015zm.554-.278c.47-.082.885-.308 1.297-.708.239-.233.496-.562.663-.85.036-.062.04-.074.038-.093-.008-.057-.224-.384-.39-.59a4.79 4.79 0 00-.52-.53A2.311 2.311 0 002.893.306a1.467 1.467 0 00-.273-.013c-.2 0-.231.002-.382.032-.26.052-.525.164-.762.32-.396.262-.8.696-1.096 1.18-.064.104-.073.125-.065.146a3.984 3.984 0 00.966 1.155c.289.23.63.394.95.46.16.033.196.036.4.034.17-.002.198-.004.277-.018z" />
    <path
      d="M2.424 3.589a2.194 2.194 0 01-.937-.356C1.095 2.971.733 2.586.431 2.11c-.086-.136-.092-.15-.079-.178.028-.063.264-.405.367-.533.132-.166.37-.411.517-.534.308-.257.645-.43 1-.513.166-.039.48-.044.668-.012.348.059.713.23 1.026.48.323.258.725.73.92 1.08l.034.06-.087.138c-.309.487-.675.88-1.064 1.14-.13.086-.405.221-.546.268-.22.072-.534.107-.763.084zm.371-.818a.97.97 0 00.185-.067.665.665 0 00.21-.159.762.762 0 00.227-.396c.03-.133.02-.336-.023-.467a.853.853 0 00-.569-.536 1.062 1.062 0 00-.418-.002.844.844 0 00-.582.545 1.01 1.01 0 00-.022.461c.068.294.306.54.595.615.106.028.28.03.397.006z"
      fill={color_fondo} id="prueba" />
    <path
      d="M2.473 2.45a.54.54 0 01-.32-.279c-.037-.076-.039-.088-.039-.218 0-.131.002-.142.039-.216a.59.59 0 01.247-.245.482.482 0 01.557.098.508.508 0 01-.144.833.369.369 0 01-.185.04.538.538 0 01-.155-.012z"
      fill={color_fondo} id="prueba2" />

    {/* <path
    d="M71.389 115.623c-17.118-1.747-32.433-9.397-46.961-23.456-8.842-8.556-17.45-19.956-23.304-30.86C.151 59.496.011 59.08.001 57.983c-.01-1.098.115-1.502 1.005-3.22 2.299-4.443 6.743-11.374 10.491-16.36C26.693 18.185 44.747 5.385 63.713 1.381 71.473-.258 80.026-.444 87.9.854c6.727 1.11 12.461 3.014 19.367 6.432 7.944 3.932 14.5 8.578 21.878 15.507 7.991 7.504 16.514 18.364 22.455 28.611 2.602 4.489 2.847 5.045 2.856 6.471.007 1.156-.11 1.491-1.288 3.709-7.19 13.536-18.995 27.892-30.505 37.095-12.09 9.667-24.732 15.22-38.15 16.76-2.599.297-10.873.414-13.123.184zm12.917-8.836c6.37-.86 12.503-2.776 18.727-5.85 12.076-5.965 23.306-15.854 33.514-29.515 3.476-4.652 8.713-12.78 8.713-13.525 0-.156-.681-1.415-1.514-2.798-3.269-5.43-7.62-11.537-11.83-16.603-2.754-3.313-10.603-11.183-13.537-13.573-9.827-8.003-19.552-12.944-29.866-15.173-7.73-1.671-16.894-1.484-24.744.507-12.224 3.099-23.405 9.915-34.512 21.039-4.396 4.402-7.544 8.039-11.266 13.015-3.512 4.695-8.832 12.886-8.832 13.599 0 .694 5.444 9.066 8.932 13.735 6.044 8.092 13.681 15.976 20.787 21.46 10.41 8.032 22.085 12.876 33.675 13.968 2.697.255 8.866.105 11.753-.286zM73.26 81.997c-9.955-1.551-18.118-9.762-19.877-19.994-.383-2.226-.335-6.486.099-8.744 1.83-9.54 9.318-17.236 18.73-19.255 2.828-.606 7.397-.602 10.09.01 7.274 1.653 13.16 6.251 16.455 12.855 3.961 7.941 3.432 17.097-1.42 24.558-1.405 2.16-4.447 5.308-6.392 6.616-5.284 3.552-11.434 4.927-17.685 3.953zm7.734-8.769c8.774-2.244 13.83-11.493 11.053-20.22-1.287-4.047-4.67-7.847-8.49-9.536-8.454-3.74-18.156.627-21.186 9.535-.82 2.41-.956 6.045-.323 8.589.754 3.029 1.926 5.07 4.254 7.41 1.66 1.67 2.34 2.188 3.83 2.925.998.493 2.474 1.075 3.282 1.293 2.05.552 5.43.554 7.58.004z" /> */}
  </svg>
);


export const ALERT_ERROR = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="currentColor"
    className="bi bi-x-circle"
    viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path
      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
  </svg>
);

export const ALERT_OK = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fontStyle={"bold"}
    fill="currentColor"
    className="bi bi-x-circle"
    viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    {/* <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/> */}
    <path
      d="M11.03 5.47a.65.65 0 0 1 .92.92l-4.5 4.5a.65.65 0 0 1-.92 0L4.05 8.47a.65.65 0 0 1 .92-.92L7 9.57l3.61-3.61z"
    />
  </svg>
);

export const ALERT_WARNING = () => (
  <svg width="40px" height="40px" viewBox="0 0 24 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>Group 2</title>
    <defs>
      <polygon id="path-1" points="0 0 24 0 24 22 0 22"></polygon>
    </defs>
    <g id="SIMBOLOS" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
      <g id="2.-Icons/Outlined/atention" transform="translate(-12.000000, -13.000000)">
        <g id="Group-2" transform="translate(12.000000, 13.000000)">
          <g id="Group">
            <g id="Group-3">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <g id="Clip-2"></g>
              <path d="M11.9997039,1.46645125 C11.4479974,1.46645125 10.9537602,1.75726647 10.6785831,2.24402104 L1.64979723,18.2113582 C1.37529618,18.6960503 1.37597229,19.2756182 1.65182557,19.7596227 C1.92767884,20.2436273 2.42056373,20.5330675 2.97091806,20.5330675 L21.0291659,20.5330675 C21.5795202,20.5330675 22.0724051,20.2436273 22.3482583,19.7596227 C22.6241116,19.2756182 22.6247877,18.6960503 22.3502867,18.2106707 L13.3215008,2.24402104 C13.0456476,1.75726647 12.5520866,1.46645125 11.9997039,1.46645125 M21.0291659,22.0002063 L2.97091806,22.0002063 C1.89928218,22.0002063 0.939880719,21.4371385 0.403048612,20.4945671 C-0.133107384,19.5513083 -0.134459606,18.4244852 0.399668057,17.4798514 L9.4284539,1.51251418 C9.96393378,0.565130298 10.9253636,0 11.9997039,0 C13.0747203,0 14.035474,0.565130298 14.57163,1.51251418 L23.6004159,17.4798514 C24.1345435,18.4244852 24.1331913,19.5513083 23.5963592,20.4945671 C23.0602032,21.4371385 22.1001256,22.0002063 21.0291659,22.0002063" id="Fill-1" fill="#23262A" mask="url(#mask-2)"></path>
            </g>
            <path d="M12.000042,14.666575 C11.6018126,14.666575 11.2786316,14.3379469 11.2786316,13.9330056 L11.2786316,5.8664925 C11.2786316,5.4615512 11.6018126,5.13292312 12.000042,5.13292312 C12.3982713,5.13292312 12.7214524,5.4615512 12.7214524,5.8664925 L12.7214524,13.9330056 C12.7214524,14.3379469 12.3982713,14.666575 12.000042,14.666575" id="Fill-4" fill="#23262A"></path>
          </g>
          <path d="M12.2588091,17.5999587 C12.0573697,17.5999587 11.8559303,17.5291456 11.6971163,17.3840817 C11.3533631,17.0712663 11.3210503,16.5473864 11.6338658,16.2036332 L11.6496784,16.1864455 C11.9631813,15.8426923 12.4953113,15.817942 12.838377,16.131445 C13.1821303,16.4442604 13.2068805,16.9763904 12.8940651,17.3201436 C12.7263135,17.5050829 12.4925613,17.5999587 12.2588091,17.5999587" id="Fill-6" fill="#23262A"></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ALERT_INFO = () => (
  <svg
    width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>Group</title>
    <g id="SIMBOLOS" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
      <g id="2.-Icons/Outlined/information" transform="translate(-12.000000, -12.000000)" fill="#23262A">
        <g id="Group"
          transform="translate(24.000000, 24.000000) scale(1, -1) translate(-24.000000, -24.000000) translate(12.000000, 12.000000)">
          <path
            d="M12,22.4516129 C6.22993548,22.4516129 1.5483871,17.7793548 1.5483871,12 C1.5483871,6.23225806 6.22296774,1.5483871 12,1.5483871 C17.739871,1.5483871 22.4516129,6.19741935 22.4516129,12 C22.4516129,17.7723871 17.7770323,22.4516129 12,22.4516129 M12,0 C5.37290323,0 0,5.37522581 0,12 C0,18.6286452 5.37290323,24 12,24 C18.6270968,24 24,18.6286452 24,12 C24,5.37522581 18.6270968,0 12,0"
            id="Fill-1"></path>
          <path
            d="M11.9285419,15.716129 C11.4725419,15.716129 11.1024774,15.3460645 11.1024774,14.8900645 L11.1024774,5.80645161 C11.1024774,5.35045161 11.4725419,4.9803871 11.9285419,4.9803871 C12.3845419,4.9803871 12.7546065,5.35045161 12.7546065,5.80645161 L12.7546065,14.8900645 C12.7546065,15.3460645 12.3845419,15.716129 11.9285419,15.716129"
            id="Fill-3"></path>
          <path
            d="M11.9922581,19.0193806 C11.7654194,19.0193806 11.5385806,18.9396387 11.3597419,18.7762839 C10.9726452,18.4240258 10.9362581,17.8340903 11.2885161,17.4477677 L11.3063226,17.4276387 C11.6593548,17.0405419 12.2585806,17.012671 12.6449032,17.3657032 C13.032,17.7179613 13.059871,18.3171871 12.7076129,18.7042839 C12.5187097,18.9125419 12.2554839,19.0193806 11.9922581,19.0193806"
            id="Fill-5"></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ALERT = ({ }) => (
  <img
    src={AlertIcon}
    alt="Warning"
    width="42"
    height="40"
    style={{ display: "inline-block" }}
  />
);

export const CALENDAR_ALT = () => (
<svg width="21px" height="24px" viewBox="0 0 21 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icons FA / 20 /calendar-alt</title>
    <g id="SIMBOLOS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="2.-Icons/Outlined/calendar-alt" transform="translate(-14.000000, -12.000000)" fill="#23262A">
            <path d="M32.7500001,15 L30.5,15 L30.5,12.5625 C30.5,12.253125 30.2468751,12 29.9375001,12 L29.5625001,12 C29.2531251,12 29,12.253125 29,12.5625 L29,15 L20,15 L20,12.5625 C20,12.253125 19.746875,12 19.4375,12 L19.0625,12 C18.753125,12 18.5,12.253125 18.5,12.5625 L18.5,15 L16.25,15 C15.0078125,15 14,16.0078125 14,17.25 L14,33.7500001 C14,34.9921876 15.0078125,36 16.25,36 L32.7500001,36 C33.9921876,36 35,34.9921876 35,33.7500001 L35,17.25 C35,16.0078125 33.9921876,15 32.7500001,15 Z M16.25,16.5 L32.7500001,16.5 C33.1625001,16.5 33.5,16.8375 33.5,17.25 L33.5,19.5 L15.5,19.5 L15.5,17.25 C15.5,16.8375 15.8375,16.5 16.25,16.5 Z M32.7500001,34.5000001 L16.25,34.5000001 C15.8375,34.5000001 15.5,34.1625001 15.5,33.7500001 L15.5,21.0000001 L33.5,21.0000001 L33.5,33.7500001 C33.5,34.1625001 33.1625001,34.5000001 32.7500001,34.5000001 Z M20.9375,27.0000001 L19.0625,27.0000001 C18.753125,27.0000001 18.5,26.7468751 18.5,26.4375001 L18.5,24.5625001 C18.5,24.2531251 18.753125,24.0000001 19.0625,24.0000001 L20.9375,24.0000001 C21.246875,24.0000001 21.5,24.2531251 21.5,24.5625001 L21.5,26.4375001 C21.5,26.7468751 21.246875,27.0000001 20.9375,27.0000001 Z M25.4375001,27.0000001 L23.5625001,27.0000001 C23.2531251,27.0000001 23.0000001,26.7468751 23.0000001,26.4375001 L23.0000001,24.5625001 C23.0000001,24.2531251 23.2531251,24.0000001 23.5625001,24.0000001 L25.4375001,24.0000001 C25.7468751,24.0000001 26.0000001,24.2531251 26.0000001,24.5625001 L26.0000001,26.4375001 C26.0000001,26.7468751 25.7468751,27.0000001 25.4375001,27.0000001 Z M29.9375001,27.0000001 L28.0625001,27.0000001 C27.7531251,27.0000001 27.5000001,26.7468751 27.5000001,26.4375001 L27.5000001,24.5625001 C27.5000001,24.2531251 27.7531251,24.0000001 28.0625001,24.0000001 L29.9375001,24.0000001 C30.2468751,24.0000001 30.5000001,24.2531251 30.5000001,24.5625001 L30.5000001,26.4375001 C30.5000001,26.7468751 30.2468751,27.0000001 29.9375001,27.0000001 Z M25.4375001,31.5000001 L23.5625001,31.5000001 C23.2531251,31.5000001 23.0000001,31.2468751 23.0000001,30.9375001 L23.0000001,29.0625001 C23.0000001,28.7531251 23.2531251,28.5000001 23.5625001,28.5000001 L25.4375001,28.5000001 C25.7468751,28.5000001 26.0000001,28.7531251 26.0000001,29.0625001 L26.0000001,30.9375001 C26.0000001,31.2468751 25.7468751,31.5000001 25.4375001,31.5000001 Z M20.9375,31.5000001 L19.0625,31.5000001 C18.753125,31.5000001 18.5,31.2468751 18.5,30.9375001 L18.5,29.0625001 C18.5,28.7531251 18.753125,28.5000001 19.0625,28.5000001 L20.9375,28.5000001 C21.246875,28.5000001 21.5,28.7531251 21.5,29.0625001 L21.5,30.9375001 C21.5,31.2468751 21.246875,31.5000001 20.9375,31.5000001 Z M29.9375001,31.5000001 L28.0625001,31.5000001 C27.7531251,31.5000001 27.5000001,31.2468751 27.5000001,30.9375001 L27.5000001,29.0625001 C27.5000001,28.7531251 27.7531251,28.5000001 28.0625001,28.5000001 L29.9375001,28.5000001 C30.2468751,28.5000001 30.5000001,28.7531251 30.5000001,29.0625001 L30.5000001,30.9375001 C30.5000001,31.2468751 30.2468751,31.5000001 29.9375001,31.5000001 Z" id="Icons-FA-/-20-/calendar-alt"></path>
        </g>
    </g>
</svg>
);

export const CHEVRON_RIGHT = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
  class="bi bi-chevron-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd"
    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
</svg>
);

export const PDF2 = ({ width = 25, height = 25 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    {/* Documento */}
    <path
      d="M6 2h10l4 4v16H6V2z"
      fill="#FFFFFF"
      stroke="#203C77"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />

    {/* Esquina doblada */}
    <path
      d="M14 2v4h4"
      fill="none"
      stroke="#203C77"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />

    {/* Banda roja */}
    <rect
      x="4"
      y="14"
      width="16"
      height="5"
      rx="1"
      fill="#D32F2F"
    />

    {/* Texto PDF */}
    <text
      x="12"
      y="17.6"
      textAnchor="middle"
      fontSize="4"
      fontWeight="bold"
      fill="#FFFFFF"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      PDF
    </text>
  </svg>
);